import React from "react";
import { Link } from "react-router-dom";
import refreshImg from '../../img/refresh.svg';

const ListGroupLinks = ({
  items,
  textProperty,
  valueProperty,
  selectedItem,
  onItemSelect,
  onRefresh
}) => {
  // 2020-10-28 console.log(items);
  return (
    <div className="list-group">
      <div style={{display: "flex", marginBottom: "10px", alignItems: "center", justifyContent : "center"}}>
         <img src={refreshImg} style={{width: "40px", cursor : "pointer"}} alt="Refresh" onClick={onRefresh} />
      </div>
      {items.map((item) => (
        <Link
          key={item[valueProperty]}
          onClick={() => onItemSelect(item)}
          to={`/senhas/${item[valueProperty]}`}
          className={
            item === selectedItem
              ? "list-group-item list-group-item-action active"
              : "list-group-item list-group-item-action"
          }
        >
          {item[textProperty]}
        </Link>
      ))}
    </div>
  );
};

ListGroupLinks.defaultProps = {
  textProperty: "name",
  valueProperty: "_id",
};

export default ListGroupLinks;
